<script setup>
import TextInput from "~/components/ui/TextInput.vue";
import FormSelect from "~/components/ui/FormSelect.vue";

const props = defineProps({
    search: {
        type: String,
        default: ''
    },
    selectedGroup: {
        type: String,
        default: ''
    },
    selectedStatus: {
        type: String,
        default: ''
    },
    selectedSort: {
        type: String,
        default: 'asc'
    },
    groupOptions: {
        type: Array,
        default: () => []
    },
    publicSide: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits([
    'update:search',
    'update:selectedGroup',
    'update:selectedStatus',
    'update:selectedSort'
]);

const sortOptions = [
    { value: 'asc', label: 'Sort date (ascending)' },
    { value: '', label: 'Sort date (descending)' },
];

const statusOptions = computed(() => {
    if (props.publicSide) {
        // Public side only shows published materials filter
        return [
            { value: 'published_materials_status:true', label: 'Materials published' },
            { value: 'published_materials_status:false', label: 'Materials not published' }
        ];
    } else {
        // Admin side shows all status filters
        return [
            { value: 'published_materials_status:true', label: 'Materials published' },
            { value: 'published_materials_status:false', label: 'Materials not published' },
            { value: 'starred_public_page:true', label: 'Starred meetings' },
            { value: 'starred_public_page:false', label: 'Unstarred meetings' }
        ];
    }
});

const searchPlaceholder = computed(() => {
    return props.publicSide ? 'Search meetings...' : 'Search meetings on public site';
});
</script>

<template>
    <div class="bg-gray-100 rounded-t-lg flex flex-col md:flex-row gap-3 md:items-center w-full py-4 px-6">
        <TextInput
            :model-value="search"
            @update:model-value="emit('update:search', $event)"
            :placeholder="searchPlaceholder"
            class="flex-1 text-sm"
        />

        <FormSelect
            :model-value="selectedGroup"
            @update:model-value="emit('update:selectedGroup', $event)"
            placeholder="Filter by group"
            :options="groupOptions"
            class="text-sm"
            clearable
            clearableText="All groups"
        />

        <FormSelect
            :model-value="selectedStatus"
            @update:model-value="emit('update:selectedStatus', $event)"
            placeholder="Filter by status"
            :options="statusOptions"
            class="text-sm"
            clearable
            clearableText="All statuses"
        />

        <FormSelect
            :model-value="selectedSort"
            @update:model-value="emit('update:selectedSort', $event)"
            placeholder="Sort newest to oldest"
            :options="sortOptions"
            class="text-sm"
        />
    </div>
</template>